import React from "react";

import axios from "axios";
import api from "../../../services/api";
import { getFiltro, mountArrayToCSV } from "../modules";
import { CSVLink, CSVDownload } from "react-csv";

import {
  Form,
  Row,
  Col,
  Input,
  Button,
  Card,
  Select,
  DatePicker,
  message,
  Modal,
  Spin
} from "antd";
import moment from "moment";

const { Option } = Select;

class RelatorioSMSHot extends React.Component {
  token = null;

  users = "";
  componentDidMount = async () => {
    const users = await api("/usuario/");
    //console.log(users)
    this.users = users.data;
  };

  state = {
    gerar_csv: false,
    data: []
  };

  createPipedriveFilter = async (data_ini, data_fin) => {
    const filtro = getFiltro(moment().format("x"), data_ini, data_fin);
    try {
      const res_token_pipedrive = await api.get("/tokens/");
      const token = res_token_pipedrive.data.pipedrive;
      const res_filter_pipedrive = await api.post(
        `https://api.pipedrive.com/v1/filters?api_token=${token}`,
        filtro
      );
      this.token = token;
      return res_filter_pipedrive.data.data.id;
    } catch (err) {
      message.error("Ocorreu um erro");
      return null;
    }
  };

  deletePipedriveFilter = async id => {
    try {
      await api.delete(
        `https://api.pipedrive.com/v1/filters/${id}?api_token=${this.token}`
      );
    } catch (err) {
      message.error("Ocorreu um erro");
    }
  };

  getData = async id => {
    let deals = [];
    let start = 0;
    let r = {
      data: {
        data: {}
      }
    };
    while (r.data.data != null) {
      r = await axios.get(
        `https://api.pipedrive.com/v1/deals?filter_id=${id}&status=all_not_deleted&start=${start}&limit=500&api_token=${this.token}`
      );
      if (r.data.data != null) deals = [...deals, ...r.data.data];
      start = start + 500;
    }
    this.deletePipedriveFilter(id);
    return deals;
  };

  handleOnSubmit = async e => {
    this.setState({ spin: true });
    e.preventDefault();
    const { form } = this.props;
    const filtro = form.getFieldsValue();
    const filter_id = await this.createPipedriveFilter(
      filtro.periodo[0],
      filtro.periodo[1]
    );
    if (filter_id == null) return;
    else {
      const deals = await this.getData(filter_id);
      ////console.log('aqui2')
      //let csv = await mountArrayToCSV(deals, filtro)

      let csv_array = [];
      const res_token_pipedrive = await api.get("/tokens/");
      const token = res_token_pipedrive.data.pipedrive;
      const wpp_hot = "171de1827d25ed254cb11d379f1b1c7b330929c4";
      const tel_hot_2 = "ab5da3c69babda6f5c6fff9c583b6396481de504";
      const tel_hot_1 = "92dfdd01aac099bc636572a05a337bbd826775dc";
      const carteira = "45d771296989bde07beb7c2eb1f24ed7ca10dcf6";
      const pasta = "f9a0b58d523b64c5a881371570b3fdefeccdc0b8";
      const BO = "e2fa8861bb2c03cb6614ebb826cda8c9245eaa98";
      const data_acidente = "507c4781804413b1621532589ecd42a31fa20a84";
      let i = 0;
      for (i = 0; i < deals.length; i++) {
        let value = deals[i];
        ////console.log('value', value)
        const res = await axios.get(
          `https://api.pipedrive.com/v1/persons/${value.person_id.value}?api_token=${token}`
        );
        const pessoa = res.data.data;
        //console.log(value)
        if (pessoa[wpp_hot] != null) {
          csv_array.push(
            `${value[pasta]},${pessoa[wpp_hot]},${value[data_acidente]},${value[carteira]},${value["owner_name"]},${value["user_id"]["id"]}`
          );
        }
        if (pessoa[tel_hot_1] != null) {
          csv_array.push(
            `${value[pasta]},${pessoa[tel_hot_1]},${value[data_acidente]},${value[carteira]},${value["owner_name"]},${value["user_id"]["id"]}`
          );
        }
        if (pessoa[tel_hot_2] != null) {
          csv_array.push(
            `${value[pasta]},${pessoa[tel_hot_2]},${value[data_acidente]},${value[carteira]},${value["owner_name"]},${value["user_id"]["id"]}`
          );
        }
      }
      this.setState({
        ...this.state,
        csv_data: csv_array,
        gerar_csv: true,
        spin: false
      });
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    let csv = "";

    if (this.state.spin) {
      return (
        <div
          style={{
            textAlign: "center",
            marginTop: "25px"
          }}
        >
          <Spin size="large" />
        </div>
      );
    }

    ////console.log(this.state.gerar_csv)
    if (this.state.gerar_csv) {
      let data = [
        [
          "pasta",
          "telefone",
          "data_acidente",
          "carteira",
          "proprietario",
          "id_proprietario",
          "link_wpp"
        ]
      ];
      const csv_data_aux = Array.from(new Set(this.state.csv_data));
      csv_data_aux.forEach(value => {
        let data_aux = value.split(",");
        //console.log(data_aux)
        this.users.map(value2 => {
          if (value2.id_pipedrive == data_aux[data_aux.length - 1]) {
            data_aux.push(value2["link_wpp"]);
            return;
          }
        });
        console.log(data_aux[1], data_aux[1].replace(/[^0-9]*/g, ""));
        data_aux[1] = data_aux[1].replace(/[^0-9]*/g, "");
        data.push(data_aux);
      });
      //console.log(data)
      csv = (
        <Modal closable={false} footer={[]} visible={this.state.gerar_csv}>
          <div style={{ textAlign: "center" }}>
            <Button type="primary">
              <CSVLink
                separator={";"}
                filename={"my-file.csv"}
                data={data}
                onClick={() => {
                  this.setState({ gerar_csv: false });
                }}
              >
                Baixar
              </CSVLink>
            </Button>
          </div>
        </Modal>
      );
    }

    //////console.log(this.users)
    return (
      <div style={{ marginTop: "25px" }}>
        <Card title="Relatório de SMS HOT (Extraído diretamente do Pipedrive)">
          <Form onSubmit={this.handleOnSubmit}>
            <Row>
              <Form.Item label="Carteira">
                {getFieldDecorator("carteira", {
                  initialValue: ["Repique HDI", "Importacao HDI"],
                  rules: [
                    {
                      type: "array",
                      required: true,
                      message: "Digite a carteira"
                    }
                  ]
                })(
                  <Select mode="multiple">
                    <Option key="Repique HDI">Repique HDI</Option>
                    <Option key="Importacao HDI">Importacao HDI</Option>
                  </Select>
                )}
              </Form.Item>
            </Row>
            <Row>
              <Form.Item label="Estado">
                {getFieldDecorator("estado", {
                  initialValue: ["all"],
                  rules: [
                    {
                      type: "array",
                      required: true,
                      message: "Selecione o estado"
                    }
                  ]
                })(
                  <Select mode="multiple">
                    <Option key="all">Todos</Option>
                    <Option key="AC">Acre</Option>
                    <Option key="AL">Alagoas</Option>
                    <Option key="AP">Amapá</Option>
                    <Option key="AM">Amazonas</Option>
                    <Option key="BA">Bahia</Option>
                    <Option key="CE">Ceará</Option>
                    <Option key="DF">Distrito Federal</Option>
                    <Option key="ES">Espírito Santo</Option>
                    <Option key="GO">Goiás</Option>
                    <Option key="MA">Maranhão</Option>
                    <Option key="MT">Mato Grosso</Option>
                    <Option key="MS">Mato Grosso do Sul</Option>
                    <Option key="MG">Minas Gerais</Option>
                    <Option key="PA">Pará</Option>
                    <Option key="PB">Paraíba</Option>
                    <Option key="PR">Paraná</Option>
                    <Option key="PE">Pernambuco</Option>
                    <Option key="PI">Piauí</Option>
                    <Option key="RJ">Rio de Janeiro</Option>
                    <Option key="RN">Rio Grande do Norte</Option>
                    <Option key="RS">Rio Grande do Sul</Option>
                    <Option key="RO">Rondônia</Option>
                    <Option key="RR">Roraima</Option>
                    <Option key="SC">Santa Catarina</Option>
                    <Option key="SP">São Paulo</Option>
                    <Option key="SE">Sergipe</Option>
                    <Option key="TO">Tocantins</Option>
                  </Select>
                )}
              </Form.Item>
            </Row>
            <Row>
              <Form.Item label="B.O">
                {getFieldDecorator("bo", {
                  initialValue: ["14", "15"],
                  rules: [
                    {
                      type: "array",
                      required: true,
                      message: "Selecione o B.O"
                    }
                  ]
                })(
                  <Select mode="multiple">
                    <Option key="14">Sim</Option>
                    <Option key="15">Não</Option>
                  </Select>
                )}
              </Form.Item>
            </Row>
            <Row>
              <Form.Item label="Período de Importação">
                {getFieldDecorator("periodo", {
                  initialValue: [moment(), moment()],
                  rules: [
                    {
                      type: "array",
                      required: true,
                      message: "Please select time!"
                    }
                  ]
                })(<DatePicker.RangePicker format="YYYY-MM-DD" />)}
              </Form.Item>
            </Row>
            <Button htmlType="submit" type="primary">
              Gerar
            </Button>
            <div style={{ marginTop: "25px" }}>{csv}</div>
          </Form>
        </Card>
      </div>
    );
  }
}

export const RelatorioSMSHotForm = Form.create({ name: "smshot" })(
  RelatorioSMSHot
);



// WEBPACK FOOTER //
// ./src/pages/Relatorios/RelatorioSMSHot/component.js